import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DynamicFilterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DynamicFilter",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m19.76 10.14-5.5 1.12a.25.25 0 0 1-.3-.2c-.01-.06 0-.12.02-.17l3.89-8.29c.06-.13 0-.29-.13-.36-.04-.02-.09-.03-.14-.02l-6.64.64c-.1.02-.19.09-.22.19L6.71 16.79c-.04.14.03.28.17.32.05.01.1.02.14 0l3.93-.88c.15-.03.29.07.32.21v.11L8.18 29.66c-.04.14.05.29.19.33.12.03.24-.02.3-.13l11.38-19.31c.1-.11.09-.27-.02-.36a.27.27 0 0 0-.26-.05Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m17.81 8.81 1.54-.27 3.13-6.16c.06-.13 0-.29-.13-.36-.04-.02-.08-.03-.13-.02l-1.5.11-3.2 6.32c-.06.13 0 .29.13.36.05.02.1.03.15.02ZM24.95 9.18l-1.58.3-9.11 15.5-.87 3.69c-.02.15.08.28.22.31.1.02.2-.03.26-.11l11.4-19.31c.08-.13.04-.29-.09-.37a.29.29 0 0 0-.24-.02Z"
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.64 30c-.09 0-.17-.01-.26-.03a1 1 0 0 1-.74-.97V19H8c-.36 0-.69-.19-.87-.5a.99.99 0 0 1 0-1l4.59-7.99c.28-.48.89-.64 1.37-.37s.64.89.37 1.37L9.73 17h4.9c.55 0 1 .45 1 1v7.26L21.53 15h-4.9c-.55 0-1-.45-1-1V3c0-.55.44-1 .99-1s1 .45 1 1v10h5.64c.36 0 .69.19.87.5s.18.69 0 1l-8.62 15c-.18.32-.52.5-.87.5"
      })
    })
  }));
};